module.exports = __webpack_public_path__ + "fonts/balanced-ic.svg";